
import {throwError, Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

@Injectable()
export class AppConfig {
  private config: Object = null;
  private env: Object = null;

  constructor(private http: HttpClient) {}

  /**
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: any) {
    return this.config[key];
  }

  /**
   * Use to get the data found in the first file (env file)
   */
  public getEnv(key: any) {
    return this.env[key];
  }

  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   */

  public load() {
    return new Promise((resolve, reject) => {
      this.http
        .get('assets/config/env.json').pipe(
        map(res => res),
        catchError(
          (error: any): any => {
            console.log('Configuration file "env.json" could not be read');
            console.log('Error: ', error);
            resolve(true);
            return throwError(error.json().error || 'Server error');
          }
        ),)
        .subscribe(envResponse => {
          this.env = envResponse;
          let request: any = null;
          console.log('ENV: ', envResponse['env']);
          request = this.http.get('assets/config/config.' + envResponse['env'] + '.json');

          if (request) {
            request.pipe(
              map(res => res),
              catchError((error: any) => {
                console.error('Error reading ' + envResponse['env'] + ' configuration file');
                resolve(error);
                return throwError(error.json().error || 'Server error');
              }))
              .subscribe(responseData => {
                this.config = responseData;
                resolve(true);
              });
          } else {
            console.error('Env config file "env.json" is not valid');
            resolve(true);
          }
        });
    });
  }
}
